import React from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';
import { CreditCard, FileText, BookOpen, Mail, Layers, Image, PenTool, StickyNote, Users, Award, Palette, ArrowRight } from 'lucide-react';
export function CapabilityGrid() {
  const services = [{
    icon: CreditCard,
    title: 'Business Cards',
    desc: 'Standard / Premium / Luxury finishes.',
    color: 'text-cyan-600',
    bg: 'bg-cyan-50 group-hover:bg-cyan-100',
    badge: 'Popular'
  }, {
    icon: FileText,
    title: 'Brochures, Flyers & Greeting Cards',
    desc: 'Marketing materials that convert.',
    color: 'text-magenta-600',
    bg: 'bg-magenta-50 group-hover:bg-magenta-100'
  }, {
    icon: BookOpen,
    title: 'Booklets & Magazines',
    desc: 'Saddle Stitched or Perfect Bound.',
    color: 'text-yellow-600',
    bg: 'bg-yellow-50 group-hover:bg-yellow-100'
  }, {
    icon: Mail,
    title: 'Printed Stationery',
    desc: 'Presentation Folders, Letterheads, Compliment Slips, Envelopes & Notepads.',
    color: 'text-purple-600',
    bg: 'bg-purple-50 group-hover:bg-purple-100'
  }, {
    icon: Layers,
    title: 'NCR Books',
    desc: 'Duplicate or Triplicate carbonless books to suit your needs.',
    color: 'text-green-600',
    bg: 'bg-green-50 group-hover:bg-green-100'
  }, {
    icon: Image,
    title: 'Posters & Banners',
    desc: 'Large format printing for maximum impact.',
    color: 'text-orange-600',
    bg: 'bg-orange-50 group-hover:bg-orange-100'
  }, {
    icon: PenTool,
    title: 'Signage & Installation',
    desc: 'Shop fronts, vehicles, and wayfinding.',
    color: 'text-blue-600',
    bg: 'bg-blue-50 group-hover:bg-blue-100',
    badge: 'Full Service'
  }, {
    icon: StickyNote,
    title: 'Decals, Stickers & Labels',
    desc: 'Custom shapes & sizes available.',
    color: 'text-cyan-600',
    bg: 'bg-cyan-50 group-hover:bg-cyan-100'
  }, {
    icon: Users,
    title: 'Apparel & Workwear',
    desc: 'Clothing that makes a lasting impression.',
    color: 'text-magenta-600',
    bg: 'bg-magenta-50 group-hover:bg-magenta-100'
  }, {
    icon: Award,
    title: 'Promotional Items',
    desc: 'Products that make your brand stand out.',
    color: 'text-yellow-600',
    bg: 'bg-yellow-50 group-hover:bg-yellow-100'
  }, {
    icon: Palette,
    title: 'Design Services',
    desc: 'Professional graphic design support.',
    color: 'text-purple-600',
    bg: 'bg-purple-50 group-hover:bg-purple-100'
  }];
  return <Section className="bg-white" id="services" data-id="element-171">
      <Container data-id="element-172">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-4" data-id="element-173">
          <div data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-175">
              Everything you need to make an{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-magenta-500" data-id="element-176">
                impression
              </span>
            </h2>
            <p className="text-gray-600 max-w-2xl text-lg" data-id="element-177">
              Comprehensive printing and signage solutions for businesses of all
              sizes.
            </p>
          </div>
          <a href="#quote" className="text-cyan-600 font-bold hover:text-cyan-700 flex items-center group" data-id="element-178">
            View all services{' '}
            <ArrowRight className="ml-1 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-179" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-180">
          {services.map(service => <Card key={service.title} className="group h-full border-gray-100 hover:border-cyan-200 hover:shadow-lg transition-all duration-300 rounded-xl" onClick={() => document.getElementById('quote')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-181">
              <div className="p-6 relative h-full flex flex-col min-h-[240px]" data-id="element-182">
                {service.badge && <span className="absolute top-4 right-4 bg-gray-900 text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wide" data-id="element-183">
                    {service.badge}
                  </span>}

                <div className="flex items-start justify-between mb-4" data-id="element-184">
                  <div className={`p-3 rounded-xl transition-colors ${service.bg}`} data-id="element-185">
                    <service.icon className={`h-6 w-6 ${service.color}`} data-id="element-186" />
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-cyan-600 transition-colors" data-id="element-187">
                  {service.title}
                </h3>
                <p className="text-gray-600 flex-grow" data-id="element-188">{service.desc}</p>

                <div className="mt-4 flex items-center text-sm font-bold text-cyan-600 opacity-0 group-hover:opacity-100 transition-opacity transform translate-y-2 group-hover:translate-y-0 duration-300" data-id="element-189">
                  Get a Quote <ArrowRight className="ml-1 h-4 w-4" data-id="element-190" />
                </div>
              </div>
            </Card>)}
        </div>
      </Container>
    </Section>;
}